module.exports = __webpack_public_path__ + "static/media/television-tv-svgrepo-com.33adac4b.svg";